import {
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IpoTranslatePipe } from '@ip-only/front-end-library';
import { Subject, takeUntil } from 'rxjs';
import { changelog } from '../changelog/changelog';
import { filterChangelogEntries } from '../changelog/changelog.helper';
import { ChangelogEntry } from '../changelog/changelog.entities';
import { isTopLevelDomainFI } from '../shared/util/deploy-helper';
import { UserData } from '../user/user';
import { UserService } from '../user/user.service';
import { applicationsTable } from './home.entities';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  currentUser: UserData | null;
  apps = applicationsTable;
  cancelSub$ = new Subject<void>();
  isDeliveryPortalFI: boolean = isTopLevelDomainFI();
  changelog = changelog;
  private readonly router = inject(Router);

  private readonly isFederatedUser = signal<boolean>(false);

  latestEntry = computed<ChangelogEntry | null>(
    () =>
      filterChangelogEntries(this.changelog, this.isFederatedUser())[0] ?? null,
  );

  constructor(
    private readonly userService: UserService,
    private readonly titleService: Title,
    private readonly translate: IpoTranslatePipe,
  ) {
    this.titleService.setTitle(
      this.translate.transform(this.isDeliveryPortalFI ? 'tabFI' : 'tabSE'),
    );
  }

  ngOnInit() {
    this.userService
      .getPortalUser$()
      .pipe(takeUntil(this.cancelSub$))
      .subscribe((user) => {
        this.currentUser = user;
        this.isFederatedUser.set(Boolean(user?.federatedUser));
      });
  }

  ngOnDestroy() {
    this.cancelSub$.next();
  }

  getExternalUserApps() {
    return this.apps.filter((app) => {
      return app.eligableUsers.some((eligableRole) =>
        this.keycloackRoles.includes(eligableRole),
      );
    });
  }

  getUserApps() {
    return this.isUserFederated ? this.apps : this.getExternalUserApps();
  }

  goToChangelog() {
    this.router.navigate(['/changelog']);
  }

  goToGuides() {
    this.router.navigate(['/guide-document']);
  }

  goToInstructions() {
    this.router.navigate(['/video-instruction']);
  }

  get keycloackRoles(): string[] {
    return this.currentUser?.roles ?? [];
  }

  get isUserFederated() {
    return Boolean(this.currentUser?.federatedUser);
  }
}
